module.exports = "\n    <input type=\"checkbox\" value=\"accept\" class=\"margin-r-5\" ng-model=\"$ctrl.ngModel\" ng-click=\"$ctrl.click()\"/>\n    I have read and agree to the <a ng-href=\"{{$ctrl.eulaLink}}\" target=\"_new\">End User Agreement</a>.\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asEula/asEula.component.html
// module id = 680
// module chunks = 0